import React, { useState, useMemo } from 'react';
import abi from "../build/contracts/Rastro.json";

const Deposit = () => {
  const RastroContractAddress = "TNqDxpdP3Ey7FHpy9iMQqzjA3R8wgHtG9P";

  const tronWeb = useMemo(() => {
    // Check if window.tronWeb is available
    
      return window.tronWeb;
    
    // Provide a default return value if tronWeb is not available

  }, []); // Empty dependency array means this useMemo callback runs only once

  const [amount, setAmount] = useState("");

  const depositStableCoin = async () => {
    try {
      if (!tronWeb) {
        throw new Error('TronWeb is not initialized.');
      }
      
      const contract = await tronWeb.contract().at(RastroContractAddress);
      console.log(contract);

      const trx = await contract.deposit(amount).send();
      console.log(trx);

      console.log("tron", trx);
      // Assuming trx is a transaction ID, use it directly
      const txId = trx.transaction.txID;
      console.log(`https://shasta.tronscan.org/#/transaction/${txId}`);
    } catch (err) {
      console.log(err.message);
    }
  };

  return (
    <div className="">
      <div className="flex  mt-28 flex-col items-center justify-center">
        <div className="max-h-auto mx-auto max-w-xl">
          <div className="mb-8 space-y-3">
            <p className="text-xl font-semibold">Deposit Tokens</p>
            <p className="text-gray-500">
              Select the token, and specify the amount of tokens you want to deposit.
            </p>
          </div>
          <form className="w-full">

            <div className="mb-6 space-y-2">
              <label className="text-sm font-medium leading-none" htmlFor="tokenType">
                Token Type
              </label>
              <select
                className="border-input bg-background ring-offset-background focus-visible:ring-ring flex h-10 w-full rounded-md border px-3 py-2 text-sm font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
                id="tokenType"
                name="tokenType"
              >
                <option value="usdt">USDT Token</option>
                {/* Add more options for other token types if needed */}
              </select>
            </div>
            <div className="mb-10 space-y-2">
              <label className="text-sm font-medium leading-none" htmlFor="tokenAmount">
                Amount of Tokens
              </label>
              <input
                className="border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring flex h-10 w-full rounded-md border px-3 py-2 text-sm font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
                id="tokenAmount"
                placeholder="Enter amount of tokens"
                type="text"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>
            <button
              type="button" // Specify button type to prevent form submission
              onClick={depositStableCoin}
              className="ring-offset-background focus-visible:ring-ring flex h-10 w-full items-center justify-center whitespace-nowrap rounded-md bg-[#2c749d] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-black/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
            >
              Deposit
            </button>
          </form>
        
        </div>
      </div>
    </div>
  );
};

export default Deposit;
